(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jl-jumpsuit-subnav"] && !Shopify.designMode) return;
  try {
    
(function(){
  var nav = document.querySelector('.jl-subnav--sticky');

  if (nav) {
    var sel = nav.getAttribute('data-header-selector');
    function setOffset(){
      var h = 0;
      if (sel) {
        var el = document.querySelector(sel);
        if (el) {
          var pos = getComputedStyle(el).position;
          if (pos === 'sticky' || pos === 'fixed') { h = el.offsetHeight; }
        }
      }
      document.documentElement.style.setProperty('--jl-header-offset', h + 'px');
    }
    setOffset();
    window.addEventListener('resize', setOffset);
    window.addEventListener('load', setOffset);
  }

  var active = document.querySelector('.jl-subnav__link.is-active');
  if (active && active.scrollIntoView) {
    try { active.scrollIntoView({inline:'center', block:'nearest'}); } catch(e){}
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
